export const de = {
  firstDayOfWeek: 1,
  accept: 'Ja',
  reject: 'Nein',
  dayNames: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],
  dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  today: 'Heute',
  clear: 'Löschen',
  upload: 'Hochladen',
  filter: 'Filter',
  equals: 'ist gleich',
  notEquals: 'ist nicht gleich',
  contains: 'enthält',
  notContains: 'enthält nicht',
  startsWith: 'beginnt mit',
  endsWith: 'endet mit',
  noFilter: 'Kein Filter',
  filterEmpty: 'Kein Filter',
  filterClear: 'Filter löschen',
  lt: 'ist kleiner als',
  gt: 'ist größer als',
  lte: 'ist kleiner oder gleich',
  gte: 'ist größer oder gleich',
  dateIs: 'ist am',
  dateIsNot: 'ist nicht am',
  dateBefore: 'ist vor',
  dateAfter: 'ist nach',
  emptyFilterMessage: 'Keine Ergebnisse gefunden',
  dateFormat: 'dd.mm.yy',
  choose: 'Auswählen',
  cancel: 'Abbrechen',
  apply: 'Übernehmen',
  selectionMessage: '{0} ausgewählt',
};
